module.exports = __webpack_public_path__ + "img/jingyan_02.fb17f527.png";